<footer
  class="site-footer"
  id="contact">
  <div class="footer-main">
    <!-- COMPANY -->
    <div class="footer-brand">
      <a
        class="footer-logo"
        href="#top"
        aria-label="Maize Trading FZC">
        <img
          [src]="company.image"
          alt="Maize Trading FZC">
      </a>
      <p>
        {{ company.description }}
</p>
      <!-- SOCIAL -->
     
      <div class="social-links">

  @for (social of socialLinks; track social.name) {
<a

      [href]="social.url"

      [title]="social.name"

      target="_blank"

      rel="noopener noreferrer">
 
      <i [class]="social.icon"></i>
 
    </a>

  }
</div>
 

    </div>
    <!-- FOOTER COLUMNS -->
    @for (
      column of footerColumns;
      track column.title
    ) {
      <div class="footer-column">
        <h3>
          {{ column.title }}
</h3>
        @for (
          link of column.links;
          track link.label
        ) {
          <a
            [href]="link.url">
            {{ link.label }}
          </a>
        }
      </div>
    }
    <!-- CONTACT -->
    <div class="footer-contact">
      <h3>
        Get In Touch
</h3>
    <!-- Address -->
<div class="contact-item">
<i class="bi bi-geo-alt-fill"></i>
<span>{{ company.location }}</span>
</div>
 
<!-- Email -->
<div class="contact-item">
<i class="bi bi-envelope-fill"></i>
<a [href]="'mailto:' + company.email">

    {{ company.email }}
</a>
</div>
 
<!-- Phone 1 -->
<div class="contact-item">
<i class="bi bi-telephone-fill"></i>
<a [href]="'tel:' + company.phone1">

    {{ company.phone1 }}
</a>
</div>
 
<!-- Phone 2 -->
<div class="contact-item">
<i class="bi bi-telephone-fill"></i>
<a [href]="'tel:' + company.phone2">

    {{ company.phone2 }}
</a>
</div>
 
      <a
        class="contact-link"
        [href]="'mailto:' + company.email">
        <span>
          Email Us
</span>
        <span class="contact-arrow">
          →
</span>
      </a>
    </div>
  </div>
  <!-- FOOTER BOTTOM -->
  <div class="footer-bottom">
    <span>
      © {{ currentYear }}
      {{ company.fullName }}.
      All rights reserved.
    </span>
    <span>
      {{ company.tagline }}
</span>
  </div>
</footer>
